export default {
  regionSelector: {
    chooseADisasterRegion: 'Selecione uma região de desastre',
    lastUpdate: 'Última atualização'
  }
}
